import { number } from './number'

export const generateReservedCredits = (creditNumber = '') => {
  const baseOptions = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900]
  const kOptions = [1500, 1750, 2000, 2250, 2500, 2750, 3000]

  const result = [
    ...baseOptions.map((units) => ({
      units,
      label: number(units),
    })),
    ...kOptions.map((units) => ({
      units,
      label: number(units),
    })),
  ]

  // Only add if creditNumber is not already in the array
  if (creditNumber && !result.some((item) => item.units === creditNumber)) {
    const newItem = {
      units: creditNumber,
      label: number(creditNumber),
    }

    result.push(newItem)
  }

  return result.sort((a, b) => a.units - b.units)
}
